/*
 *   File : editor.js
 *   Author : https://evoqins.com
 *   Description : editor component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { useMemo } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import PropTypes from "prop-types";
import "../../Style/Components/input.scss";

export default function TextEditor({
  value = "",
  onChange = () => {},
  readOnly = false,
  placeholder = "Start typing...",
  config = {},
  className = "",
  error,
}) {
  const defaultConfig = useMemo(() => {
    return {
      placeholder,
      toolbar: {
        items: [
          "|",
          "fontFamily",
          "fontSize",
          "fontColor",
          "|",
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "removeFormat",
          "|",
          "link",
          "blockQuote",
          "code",
          "codeBlock",
          "|",
          "bulletedList",
          "numberedList",
          "todoList",
          "|",
          "outdent",
          "indent",
          "|",
          "alignment",
          "|",
          "horizontalLine",
          "|",
          "undo",
          "redo",
        ],
      },

      ...config,
    };
  }, [placeholder, config]);

  return (
    <div
      className={`text-editor-wrapper e-input ${
        error ? "e-border-error" : "e-border-input"
      } bg-transparent ${className}`}
    >
      <CKEditor
        editor={ClassicEditor}
        config={{ ...defaultConfig }}
        data={value}
        disabled={readOnly}
        onReady={(editor) => {}}
        onChange={(event, editor) => {
          const data = editor.getData();
          onChange(data);
        }}
        onBlur={(event, editor) => {
          // optional: handle blur
        }}
        onFocus={(event, editor) => {
          // optional: handle focus
        }}
      />
      <style>{`
        .text-editor-wrapper :global(.ck-editor__editable_inline) {
          min-height: 180px;
          max-height: 700px;
          overflow-y: auto;
          border-radius: 12px;
          padding: 24px;
          background: transparent;
        }
      `}</style>
    </div>
  );
}

TextEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  config: PropTypes.object,
  className: PropTypes.string,
};
